'use client';

import React from 'react';

import { getNodesFromConnection } from '../../../../helpers/graphql';
import {
  GetDiscoveredBrands,
  GetDiscoveredBrands_entry_edges_node,
} from '../../../../interfaces/graphql';
import { BrandCard } from '../components/BrandCard';
import { ContinuousCarousel } from '../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../../../../components/Container/Container';

interface IProps {
  brands: GetDiscoveredBrands;
  variant: 'FeaturedBrand' | 'ActiveBrand';
  title: string;
}

export const FilteredBrands = ({ brands, variant, title }: IProps) => {
  const brandNodes = getNodesFromConnection<GetDiscoveredBrands_entry_edges_node>(brands.entry);

  return (
    <Container>
      <ContinuousCarousel
        dataTestId={`${variant}-Carousel`}
        title={title}
        outerClass="mb-md"
        childrenClassName=""
      >
        {brandNodes.map(brand => (
          <BrandCard key={brand._id} brand={brand} />
        ))}
      </ContinuousCarousel>
    </Container>
  );
};
